import ApiBase from '../../ApiBase';

class Forms extends ApiBase {
    route = '/admin/services/forms';

    /**
     * @method save
     * @param {array} forms
     * @return {Promise<*>}
     */
    save = (forms) => this.patch(null, {forms}, null, 204);
}

export default new Forms();
